import { Account, ACCOUNT_GROUP_TYPE, CardStatus } from '@zeusm/personal/core/entities';
import { getAccountsResMock } from '@zeusm/personal/shell';

import { GetSecureCardDetailsRes } from '../entities/cards';

export const cardMock: Account = {
  id: 'test-account-id',
  currencyId: '019a1f66-0c1d-b7b7-1dfb-371f34caf85f',
  balance: '0',
  type: ACCOUNT_GROUP_TYPE.CLIENT,
  status: 'Active',
  createdAt: '2025-11-03T00:00:00.000Z',
  updatedAt: '2025-11-03T00:00:00.000Z',
  card: {
    id: 'test-card-id',
    pan: '5558941234567890',
    status: CardStatus.Active,
    createdAt: '2025-11-03T00:00:00.000Z',
    cardHolder: 'Test User',
  },
  cardProduct: {
    id: 'test-product',
    brand: 'Mastercard',
    bin: 555894,
    dailyVolumeLimit: '4000',
    monthlyVolumeLimit: '15000',
  },
};

export const cardProductsMock = {
  cardProducts: [
    {
      id: '1',
      binCode: '555894',
      cardBrand: 'Mastercard',
      currencyId: '019a1f66-0c1d-b7b7-1dfb-371f34caf85f',
      volumeLimitPerDay: '4000',
      volumeLimitPerMonth: '15000',
      prohibitedUse: [
        { label: 'Gambling', icon: 'i-gaming' },
        { label: 'Cryptocurrency exchanges', icon: 'chart-up' },
        { label: 'Adult content', icon: 'gift' },
      ],
      prohibitedCountries: [
        'Russia',
        'Abkhazia',
        'Belarus',
        'Crimea',
        'Donetsk People’s Republic (DNR)',
        'DPRK (North Korea)',
        'Gaza Strip',
        'Iran',
        'Iraq',
        'Kherson',
        'Luhansk People’s Republic (LNR)',
        'Northern Cyprus',
        'South Ossetia',
        'Venezuela',
        'Zaporizhzhia',
      ],
      permittedUse: [
        { label: 'Online shopping', icon: 'cart' },
        { label: 'Travel', icon: 'earth' },
        { label: 'Entertainment', icon: 'gift' },
        { label: 'Restaurants', icon: 'bag' },
      ],
    },
    {
      id: '2',
      binCode: '444455',
      cardBrand: 'Visa',
      currencyId: '019a1f66-0c1d-d332-30e4-1dd04fdcacfd',
      volumeLimitPerDay: '1000',
      volumeLimitPerMonth: '5000',
      prohibitedUse: [
        { label: 'Gambling', icon: 'i-gaming' },
        { label: 'Cash advances', icon: 'atm' },
      ],
      permittedUse: [
        { label: 'Business expenses', icon: 'bag' },
        { label: 'Software subscriptions', icon: 'add-square' },
        { label: 'Travel', icon: 'earth' },
      ],
    },
    {
      id: '3',
      binCode: '515151',
      cardBrand: 'Mastercard',
      currencyId: '019a1f66-0c1d-59ad-3cef-885093240fe6',
      volumeLimitPerDay: '5000',
      volumeLimitPerMonth: '10000',
      prohibitedUse: [
        { label: 'Cryptocurrency exchanges', icon: 'chart-up' },
        { label: 'Wire transfers', icon: 'p-transfer' },
      ],
      permittedUse: [
        { label: 'General spend', icon: 'bag' },
        { label: 'Online shopping', icon: 'cart' },
        { label: 'Contactless payments', icon: 'add-square' },
      ],
    },
  ],
  count: 3,
};

export const secureCardDetailsMock: GetSecureCardDetailsRes = {
  cvn: '123',
  number: '4111111111111111',
  validTill: '12/29',
  password: '0000',
};

export function getCreatedCardAccountMock(): Account {
  return getAccountsResMock.cardAccounts[0];
}

export function getReissuedCardAccountMock(): Account {
  return getAccountsResMock.cardAccounts[0];
}

export function getCardWithStatusMock(id: string, status: CardStatus): Account {
  return {
    ...cardMock,
    card: {
      ...cardMock.card,
      id,
      status,
    },
  };
}
